import { serverRouteConfig } from "@server/server-route-config"
import { handleShortLinkSearch } from "@server/short-links-api"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/short-links/search")(
  serverRouteConfig({
    server: {
      handlers: {
        // POST for a read: the panel sends the record's public URL, which is
        // request data rather than an addressable resource.
        POST: async ({ request }) => handleShortLinkSearch(request),
      },
    },
  })
)
